import { render, staticRenderFns } from "./upgrade-to-pro.vue?vue&type=template&id=5530f5bf&scoped=true&"
import script from "./upgrade-to-pro.vue?vue&type=script&lang=js&"
export * from "./upgrade-to-pro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530f5bf",
  null
  
)

export default component.exports